"use client"
import { useEffect, useState } from "react";
import {fetchCountryData} from "@/context/utils"
import { usePathname } from "next/navigation"

const CountryInfo = () => {
  const pathName = usePathname();
  const isAfricaPage = pathName === "/africa";

  useEffect(() => {
    fetchCountryData({isAfricaPage});
  }, []);

  return null;
}

export default CountryInfo